import { render, staticRenderFns } from "./StepRegistrationReport.vue?vue&type=template&id=261c20ca&scoped=true&"
import script from "./StepRegistrationReport.vue?vue&type=script&lang=js&"
export * from "./StepRegistrationReport.vue?vue&type=script&lang=js&"
import style0 from "./StepRegistrationReport.vue?vue&type=style&index=0&id=261c20ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261c20ca",
  null
  
)

export default component.exports